import { Box, Card, Typography } from "@mui/material";

function StatCard({ heading, value, subtext, icon, accentColor = '#FF5200' }) {
    return (
        <Card
            sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 3,
                p: '20px 20px 14px',
                flex: 1,
                minWidth: 160,
                background: '#FFFFFF',
                boxShadow: '0 2px 16px rgba(0,0,0,0.05)',
                border: '1px solid rgba(255,82,0,0.07)',
                transition: 'transform 0.22s ease, box-shadow 0.22s ease',
                '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: `0 8px 28px rgba(255,82,0,0.11)`,
                },
            }}
        >
            {/* Top accent bar */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0,
                    height: 3,
                    background: `linear-gradient(90deg, ${accentColor} 0%, #FF8C42 100%)`,
                    borderRadius: '3px 3px 0 0',
                }}
            />

            {icon && (
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '10px',
                        background: `linear-gradient(135deg, ${accentColor}28 0%, ${accentColor}10 100%)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1.25,
                        color: accentColor,
                    }}
                >
                    {icon}
                </Box>
            )}

            <Typography
                sx={{
                    fontSize: 10,
                    fontWeight: 700,
                    fontFamily: 'Quicksand',
                    color: '#9CA3AF',
                    textTransform: 'uppercase',
                    letterSpacing: 0.8,
                    mb: 0.4,
                }}
            >
                {heading}
            </Typography>

            <Typography
                sx={{
                    fontSize: 26,
                    fontWeight: 900,
                    fontFamily: 'Quicksand',
                    color: '#0F172A',
                    lineHeight: 1.15,
                    mb: 0.4,
                }}
            >
                {value}
            </Typography>

            {subtext && (
                <Typography
                    sx={{
                        fontSize: 11,
                        fontWeight: 600,
                        fontFamily: 'Quicksand',
                        color: '#CBD5E1',
                        textTransform: 'capitalize',
                    }}
                >
                    {subtext}
                </Typography>
            )}
        </Card>
    );
}

export default StatCard;
